var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.14 20.2001C29.14 19.5601 29.08 18.9501 28.98 18.3601H20.5V21.8401H25.34C25.13 22.9601 24.5 23.9201 23.54 24.5601V26.8201H26.45C28.15 25.2501 29.13 22.9501 29.13 20.2001H29.14Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 29C22.93 29 24.97 28.19 26.46 26.82L23.55 24.56C22.74 25.1 21.71 25.42 20.5 25.42C18.16 25.42 16.17 23.84 15.46 21.71H12.45V24.04C13.93 26.98 16.97 29 20.49 29H20.5Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.46 21.71C15.28 21.17 15.18 20.59 15.18 20C15.18 19.41 15.28 18.83 15.46 18.29V15.96H12.45C11.84 17.18 11.49 18.55 11.49 20C11.49 21.45 11.84 22.83 12.45 24.04L15.46 21.71Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 14.58C21.82 14.58 23.01 15.03 23.94 15.93L26.52 13.35C24.96 11.9 22.92 11.01 20.5 11.01C16.98 11.01 13.94 13.03 12.46 15.97L15.47 18.3C16.18 16.17 18.16 14.59 20.51 14.59L20.5 14.58Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.b417360bd51d4d18593e065872c9d90d.svg";
export { ForwardRef as ReactComponent };